import {ISiteMapService} from './sitemap.service.interface';
import {ServiceBase} from '../ServiceBase';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {SiteMapNode} from './sitemap-node';
import {action, observable} from 'mobx';
import {IBreadcrumb} from './breadcrumbs/breadcrumb.interface';
import {UriPath} from '../location/uri-path/uri-path';

export class SiteMapService extends ServiceBase implements ISiteMapService {

  private _root: SiteMapNode;
  private _flatSiteMapByUrl: {[key: string]: SiteMapNode};

  constructor(services: IServiceFactoryExtended) {
    super(services);
    this._initSiteMap();
    this.reaction(
      () => this.services.location.currentUri,
      (uri) => {
        this._setBreadcrumbs(this._createBreadCrumbs(uri.pathName));
      },
      {
        fireImmediately: true
      });
  }

  private _initSiteMap() {
    let siteMap = this.services.configuration.startupConfiguration.b2c.sitemap
    this._root = new SiteMapNode(siteMap.title, siteMap.url, siteMap.children);
    this._flatSiteMapByUrl = this._root.toFlatSiteMap();
  }

  @observable.ref
  breadcrumbs: IBreadcrumb[] = [];

  @action.bound
  private _setBreadcrumbs(breadcrumbs: IBreadcrumb[]) {
    this.breadcrumbs = breadcrumbs;
  }


  private _createBreadCrumbs(uriPath: UriPath): IBreadcrumb[] {
    if(!uriPath) {
      return [];
    }

    if(uriPath.isEmpty) {
      return [];
    }

    let uriParts = uriPath.toArray();
    if(uriParts[0] !== '/') {
      uriParts = ['/', ...uriParts];
    }

    let breadcrumbs = this._root.createBreadcrumbs(uriParts, this.services);
    if(breadcrumbs.length < uriParts.length) {
      this.services.logger.warning(`URL ${uriPath} was not found in the sitemap`);
      return [];
    }

    if(breadcrumbs.length <= 1) {
      return [];
    }

    return breadcrumbs;
  }

  isUrlInSiteMap(url: string): boolean {
    if(this._flatSiteMapByUrl[url]) {
      return true;
    }
    else {
      return false;
    }
  }



}
